import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import rawMatIcon from "../../../../../assets/new-product-detail-cats/header-icons/raw-material-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import { getProductInventory } from "../../../../../apis/Product/ProductInventoryApi";
import { createSystemBoundaryProductInventory } from "../../../../../apis/Product/ProductInventoryApi";

const RawMaterialIcon = () => (
  <img src={rawMatIcon} alt="Raw Material Icon" width={76} height={76} />
);

const RawMaterialHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  handleShowCategory,
  isCategory,
  showCategory,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");

  useEffect(() => {
    getProductInventory({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`raw-material-category ${className || ""}`}
      leftBoxProps={{
        icon: <RawMaterialIcon />,
        title: t("RAW_MATERIALS"),
        description: t("RAW_MATERIALS_INTRO"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductInventory,
        handleShowCategory: handleShowCategory,
        isCategory: isCategory,
        showCategory: showCategory,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default RawMaterialHeader;
